import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NoMaintenanceGuard } from '../core/guards/no-maintenance.guard';
import { AuthComponent } from './containers/auth-wrapper/auth.component';
import { ChangePasswordContainerComponent } from './containers/change-password/change-password-container.component';
import {
  EmailVerificationTokenComponent,
} from './containers/email-verification-token/email-verification-token.component';
import { EmailVerificationComponent } from './containers/email-verification/email-verification.component';
import { LoginComponent } from './containers/login/login.component';
import { RegistrationComponent } from './containers/registration/registration.component';
import { SendEmailContainerComponent } from './containers/send-email/send-email-container.component';
import { VerifyCodeContainerComponent } from './containers/verify-code/verify-code-component-container.component';
import { EmailVerificationGuard } from './guards/email-verification.guard';
import { GoogleTokenGuard } from './guards/google-token.guard';
import { NotAuthenticatedGuard } from './guards/not-authenticated-guard';
import { RegulationsResolver } from './resolvers/regulations.resolver';
import { RemovedAccountComponent } from './containers/removed-account/removed-account.component';
import { After2FaContainerComponent } from './containers/after-2fa/after-2fa-container.component';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    canActivate: [NoMaintenanceGuard, NotAuthenticatedGuard],
    children: [
      {
        component: RegistrationComponent,
        path: 'register/:email',
      },
      {
        canActivate: [GoogleTokenGuard],
        component: RegistrationComponent,
        path: 'register',
        pathMatch: 'full',
        resolve: {
          regulations: RegulationsResolver,
        },
      },
      {
        canActivate: [GoogleTokenGuard],
        component: LoginComponent,
        path: 'login',
        pathMatch: 'full',
      },
      { path: 'after-2fa',
        component: After2FaContainerComponent
      },
      {
        canActivate: [GoogleTokenGuard],
        component: RemovedAccountComponent,
        path: 'removed',
        pathMatch: 'full',
      },
      {
        canActivate: [EmailVerificationGuard],
        component: EmailVerificationComponent,
        path: 'emailVerification/:verificationState',
      },
      {
        component: EmailVerificationTokenComponent,
        path: 'emailVerificationToken/:verificationToken',
      },
      {
        canActivate: [EmailVerificationGuard],
        component: EmailVerificationComponent,
        path: 'emailVerification',
        pathMatch: 'full',
      },
      {
        path: 'resetPassword',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'sendEmail',
          },
          {
            component: SendEmailContainerComponent,
            path: 'sendEmail',
          },
          {
            component: VerifyCodeContainerComponent,
            path: 'verifyCode',
          },
          {
            component: ChangePasswordContainerComponent,
            path: 'changePassword/:verificationCode',
          },
        ],
      },
    ],
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class AuthRoutingModule {}
